import { useCallback, useState } from 'react';

import { AydenCard } from '../AdyenCard/AdyenCard';
import { EPaymentProvider } from '../../../../../../contracts';
import { usePaymentState } from '../../../../hooks/use-payment-state';
import { useAdyenSavedCardSubmit } from '../../hooks/use-adyen-saved-card-submit';
import { SavedCardsContainer } from '../../../SavedCardContainer/SavedCardContainer';
import { AdyenThreeDSComponent } from '../AdyenThreeDSContainer/AdyenThreeDSContainer';

export function AdyenCardContainer() {
  const { handleSubmit, threeDSComponent } = useAdyenSavedCardSubmit();
  const savedCards = usePaymentState((state) => state.savedCards);
  const hasSavedCards = Boolean(
    savedCards.filter((card) => card.paymentProvider === EPaymentProvider.adyen).length
  );
  const [savedCardFlow, setSavedCardFlow] = useState({
    show: hasSavedCards,
    defaultSavedCardChecked: false,
  });
  const setIsApmLoading = usePaymentState((state) => state.setIsApmLoading);
  const setIsPaymentElementLoading = usePaymentState((state) => state.setIsPaymentElementLoading);

  const onReady = useCallback(() => {
    setIsApmLoading(false);
    setIsPaymentElementLoading(false);
  }, [setIsPaymentElementLoading, setIsApmLoading]);

  const showCardFlow = () => {
    setSavedCardFlow({ show: false, defaultSavedCardChecked: true });
  };

  if (savedCardFlow.show) {
    return (
      <>
        <SavedCardsContainer
          onReady={onReady}
          paymentProvider={EPaymentProvider.adyen}
          onPayClicked={handleSubmit}
          showCardFlow={showCardFlow}
        />
        <AdyenThreeDSComponent threeDSComponent={threeDSComponent} />
      </>
    );
  }

  return (
    <AydenCard
      savedCardProps={{
        defaultSaveCardChecked: savedCardFlow.defaultSavedCardChecked,
        onBackButtonClicked: () => setSavedCardFlow({ show: true, defaultSavedCardChecked: false }),
        showBackButton: hasSavedCards,
      }}
    />
  );
}
